<script setup lang="ts">
import type { ReferenceStandard } from '@/types/ReferenceStandard'
import type { User } from '@/types/User'
import type { LeaderboardLeader } from '@/types/LeaderboardLeader'

export interface Props {
  user: User | LeaderboardLeader | null
}

const props = withDefaults(defineProps<Props>(), {
  user: null
})
</script>

<template>
  <div
    v-if="user"
    class="user-profile-icon"
    :style="{
      'background-image': 'url(' + user.profileIcon + ')'
    }"
  ></div>
</template>

<style scoped lang="scss">
.user-profile-icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  border: 2px solid var(--primary-accent-color);
  background: var(--ych-grey-600) no-repeat center center;
  background-size: cover;
}
</style>
